import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";
import ReactQuill from "react-quill";
import Switch from "../../components/switch";
import ImageUploader from "../../components/upload-image";
import slugify from "slugify";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    ["code-block"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "code-block",
];

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, id } = useAddWorkProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <Label label={id ? "Update Blog Details" : "Add Blog Details"} className="text-[18px] text-black" />
      <Formik initialValues={initialValues} enableReinitialize={true} onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <div className="flex items-center space-x-2">
                <Label label="Is Published ?" className="text-black mr-4 mt-3 text-[15px]" />
                <Switch
                  className="pt-1"
                  type="switch"
                  name="is_publish"
                  onChange={(val) => setFieldValue("works.is_publish", val)}
                  checked={values.works.is_publish}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="flex flex-col">
                <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.meta_title" rootClassName="w-full" />
              </div>

              <div className="flex flex-col">
                <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.meta_keywords" rootClassName="w-full" />
              </div>
              <div className="flex flex-col ">
                <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.meta_description" rootClassName="w-full" />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 mt-2 gap-3">
              <div className="flex flex-col">
                <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput
                  name="works.title"
                  rootClassName="w-full"
                  value={values.works?.title || ""}
                  onChange={(e) => {
                    const newTitle = e.target.value;
                    setFieldValue("works.title", newTitle);
                    setFieldValue("works.slug_url", slugify(newTitle, { lower: true }));
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Label label="Slug URL" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput
                  name="works.slug_url"
                  rootClassName="w-full"
                  value={values.works?.slug_url || ""}
                  onChange={(e) => {
                    setFieldValue("works.slug_url", e.target.value);
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Label label="Keywords (' , ' seperated)" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.keywords" rootClassName="w-full" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-2">
              <div className="flex flex-col">
                <Label label="Author Name" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.author" rootClassName="w-full" />
              </div>

              <div className="flex flex-col">
                <Label label="Rating" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.rating" rootClassName="w-full" />
              </div>

               <div className="flex flex-col">
                <Label label="Banner Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.alt_tag" rootClassName="w-full" />
              </div>
            </div>
            <div className="w-full mt-3">
              <div className="flex flex-col">
                <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                <ReactQuill
                  theme="snow"
                  value={values.works.description}
                  onChange={(e) => setFieldValue("works.description", e)}
                  modules={modules}
                  formats={formats}
                />
              </div>
            </div>
            <Label label="Banner Image" className="mt-3 text-black text-[15px]" />
            <div className="w-full  mb-5 ">
              <ImageUploader
                imageUrl={values.works.banner_img}
                onChange={(res) => {
                  setFieldValue(`works.banner_img`, res?.data?.file_url || "");
                }}
              />
            </div>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
